<template>
  <div
    class="modal is-active" style="z-index:9999999"
    @click="handleCloseOutside">
    <RegimenCheckerModal v-if="modal.modalType === 'regimenChecker'"/>
    <UpdateCurlNote v-if="modal.modalType === 'updateCurlNote'"/>
    <AddPaymentMethod v-if="modal.modalType === 'addPaymentMethod'"/>
    <CurlStatus v-if="modal.modalType === 'createCurlStatus'" />
    <RegimenBuilderModal v-if="modal.modalType === 'RegimenBuilderModal'" />
    <RegimenCalendarModal v-if="modal.modalType === 'RegimenCalendarModal'"/>
    <ShowUserCalendarElements v-if="modal.modalType === 'showUserCalendarElements'" />
    <InsightRateModal 
      v-if="modal.modalType === 'showInsightRateModal'" 
      :item="modal.data"/>
    <AddUserModal v-if="modal.modalType === 'addUser'" />
    <EditUserModal 
      v-if="modal.modalType === 'editUser'" 
      :item="modal.data"/>
    <AddInsightModal v-if="modal.modalType === 'addInsight'" />
    <EditInsightModal v-if="modal.modalType === 'editInsight'" :insightId = "modal.data.ID"/>
    <AddRegimenModalVue v-if="modal.modalType === 'addRegimen'" />
    <EditRegimenModalVue v-if="modal.modalType === 'editRegimen'" :regimenId = "modal.data.ID" />
    <InfoInsightModal 
      v-if="modal.modalType === 'infoInsight'" 
      :item="modal.data"/>
    <div class="modal-close"/>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import RegimenCheckerModal from "./modals/RegimenChecker/RegimenCheckerModal";
import UpdateCurlNote from "./modals/CurlNotesModal/UpdateCurlNote";
import AddPaymentMethod from "./modals/AddPaymentMethod/AddPaymentMethod";
import CurlStatus from "./modals/AddCurlStatus/CurlStatus";
import RegimenBuilderModal from "./modals/RegimenBuilder/RegimenBuilderModal";
import RegimenCalendarModal from "./modals/RegimenCalendarModal/RegimenCalendarModal";
import ShowUserCalendarElements from './modals/RegimenCalendarModal/ShowUserCalendarElements';
import InsightRateModal from "./modals/InsightRate/InsightRateModal";
import AddUserModal from "./modals/AdminModals/AddUserModal";
import EditUserModal from "./modals/AdminModals/EditUserModal";
import AddInsightModal from "./modals/AdminModals/AddInsightModal";
import AddRegimenModalVue from "./modals/AdminModals/AddRegimenModal.vue";
import EditRegimenModalVue from "./modals/AdminModals/EditRegimenModal.vue";
import EditInsightModal from "./modals/AdminModals/EditInsightModal.vue";
import InfoInsightModal from "./modals/Insight/InfoInsightModal";

export default {
    components: {
    InfoInsightModal,
    AddRegimenModalVue,
    EditRegimenModalVue,
    AddInsightModal,
    EditInsightModal,
    EditUserModal,
    AddUserModal,
    AddPaymentMethod,
    UpdateCurlNote,
    RegimenCheckerModal,
    CurlStatus,
    RegimenBuilderModal,
    RegimenCalendarModal,
    ShowUserCalendarElements,
    InsightRateModal,
},
    computed: {
        ...mapGetters(['modal']),
    },

    methods: {
      handleCloseOutside() {
        window.addEventListener("click", (event) => {
          if (this.modal && event.target.classList.contains('modal')) {
            this.$store.commit('HIDE_MODAL');
          }
        })
      }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue